// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6777f912","977":"f05bc032"}[chunkId] + ".chunk.js";
};